import { Factory } from "lucide-react"
import type { LocalizedText, NotificationRenderer } from "../../types"
import { navigateForAction } from "../actionRoutes"

// resource_type is "declaration" for this type — icon mirrors the sidebar's
// Supplier Studio entry (see declarationReadyForReview.tsx for the source);
// the "error" accent chip carries the failure signal.
// Payload is untrusted: type-guard before using a field as a param.
export const declarationProcessingFailed: NotificationRenderer = {
  icon: Factory,
  accent: "error",
  // Popover rows show only the title (no description), so it needs to carry
  // context on its own: prefer supplier, then filename, then fully generic.
  title: (payload): LocalizedText => {
    if (typeof payload?.supplierName === "string") {
      return {
        key: "NOTIF/DECL_FAILED/TITLE",
        params: { supplier: payload.supplierName },
      }
    }
    if (typeof payload?.filename === "string") {
      return {
        key: "NOTIF/DECL_FAILED/TITLE_FILENAME",
        params: { filename: payload.filename },
      }
    }
    return { key: "NOTIF/DECL_FAILED/TITLE_GENERIC" }
  },
  description: (payload) =>
    typeof payload?.filename === "string"
      ? { key: "NOTIF/DECL_FAILED/DESC", params: { filename: payload.filename } }
      : { key: "NOTIF/DECL_FAILED/DESC_GENERIC" },
  cta: "NOTIF/CTA/TRY_AGAIN",
  onAction: navigateForAction,
}
